import { CloseOutlined } from '@ant-design/icons';
import { Modal, Form, Title } from '@bancobarigui/barihaus';
import { useEffect } from 'react';

import { ProponentForm } from './ProponentForm';
import { ModalFooter } from '@/components/ModalFooter';

import { ProponentFormData, useProponentModal } from './useProponentModal';

type Props = {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: ProponentFormData) => void;
  initialData?: (ProponentFormData & { id?: string }) | undefined;
};

export function ProponentModal({ open, onClose, onSubmit, initialData }: Props) {
  const { form, handleFormSubmit } = useProponentModal({
    onSubmit,
    onClose,
  });

  useEffect(() => {
    if (open && initialData) {
      form.setFieldsValue(initialData);
    } else if (!open) {
      form.resetFields();
    }
  }, [open, initialData, form]);

  return (
    <Modal
      centered
      open={open}
      width={900}
      footer={null}
      onCancel={onClose}
      className="space-y-8"
      closeIcon={<CloseOutlined />}
    >
      <Title level={2}>{initialData ? 'Editar Proponente' : 'Adicionar Proponente'}</Title>

      <Form form={form} layout="vertical" onFinish={handleFormSubmit}>
        <ProponentForm />

        <ModalFooter onClose={onClose} />
      </Form>
    </Modal>
  );
}
